var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/inherits");

var Raw = require('./raw');

var Ref =
/*#__PURE__*/
function (_Raw) {
  "use strict";

  _inherits(Ref, _Raw);

  function Ref(client, ref) {
    var _this;

    _classCallCheck(this, Ref);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Ref).call(this, client));
    _this.ref = ref;
    _this._schema = null;
    _this._alias = null;
    return _this;
  }

  _createClass(Ref, [{
    key: "withSchema",
    value: function withSchema(schema) {
      this._schema = schema;
      return this;
    }
  }, {
    key: "as",
    value: function as(alias) {
      this._alias = alias;
      return this;
    }
  }, {
    key: "toSQL",
    value: function toSQL() {
      var string = this._schema ? "".concat(this._schema, ".").concat(this.ref) : this.ref;
      var formatter = this.client.formatter(this);
      var ref = formatter.columnize(string);
      var sql = this._alias ? "".concat(ref, " as ").concat(formatter.wrap(this._alias)) : ref;
      this.set(sql, []);
      return _get(_getPrototypeOf(Ref.prototype), "toSQL", this).apply(this, arguments);
    }
  }]);

  return Ref;
}(Raw);

module.exports = Ref;